module.exports = __webpack_public_path__ + "img/step-3@2x.41abadb8.png";